import { Box } from '@mui/material';
import { fMonthDayTimeYear, hoursLeftToDate } from '../../utils/formatTime';
import Iconify from '../iconify';

const renderIcon = (value, icon) => <Box>
  <Iconify icon={icon} width={13} height={13} /> {value}
</Box>;

const message = {
  field: 'message',
  headerName: 'Type',
  flex: .7,
  minWidth: 40,
  renderCell: (params) => {
    const missed = params.value === 'Cutoff' && new Date(params.row.date) < new Date();
    const elapsed = missed ? hoursLeftToDate(params.row.date).replace(' ago', '') : '';
    return <Box sx={{ color: missed ? 'error.main' : 'inherit' }}>
      {missed ? `Cutoff missed by ${elapsed}` : params.value}
    </Box>;
  },
};

const vendor = {
  field: 'vendor',
  headerName: 'Vendor',
  flex: 1,
  minWidth: 100,
};

const facility = {
  field: 'facility',
  headerName: 'Facility',
  flex: 1,
  minWidth: 100,
};

const shipDate = {
  field: 'date',
  headerName: 'Date',
  flex: 1,
  minWidth: 110,
  renderCell: (params) => {
    const missed = params.row.message === 'Cutoff' && new Date(params.value) < new Date();
    return <Box sx={{ color: missed ? 'error.main' : 'inherit' }}>
      {renderIcon(fMonthDayTimeYear(params.value), 'material-symbols:calendar-today-outline')}
    </Box>;
  },
  type: 'customDate',
  valueGetter: (params) => new Date(params.value),
};

const SHIP_DAYS = [
  message,
  vendor,
  facility,
  shipDate,
];

export { SHIP_DAYS };
